import React from "react";

// TikTok glyph (lucide-react has no TikTok icon).
export const TikTokIcon = ({ size = 20, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={className}
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M16.5 3c.3 2.1 1.5 3.6 3.5 3.9v2.5c-1.3.1-2.5-.2-3.6-.9v6.1c0 3.3-2.5 5.6-5.6 5.6-2.9 0-5.3-2.2-5.3-5.1 0-3 2.4-5.2 5.6-5v2.6c-.4-.1-.8-.2-1.2-.1-1.3.1-2.2 1-2.2 2.4 0 1.4 1 2.4 2.4 2.4 1.5 0 2.4-1 2.4-2.7V3h3.6z" />
  </svg>
);

export default TikTokIcon;
